import { Button, Chip, IconButton, InputLabel, Tab, Tabs } from '@material-ui/core';
import { Close } from '@material-ui/icons';
import CancelIcon from '@material-ui/icons/Cancel';
import ChipInput from 'material-ui-chip-input';
import React, { useEffect, useReducer, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  RoomTypeFeatures,
  SuggestedRoomTypeFeatures,
} from '../../../../../constants/FeaturesConst';
import { ASSET_ROOM_TYPES } from '../../../../../constants/PropertyConst';
import CustomSelect from '../../../../../shared/form-controls/custom-select/Custom-Select';
import CustomTextField from '../../../../../shared/form-controls/custom-text-field/Custom-Text-Field';
import { getProcessedImages } from '../../../../../shared/image-upload/ImageProcessor';
import ImageUpload from '../../../../../shared/image-upload/ImageUpload';
import LinearProgressBar from '../../../../../shared/progress-bar/Progress';
import { formDataValidate, handleValidation } from '../../../../../utils/formUtils';
import { notificationManager } from '../../../../../utils/NotificationUtils';
import { creatNewRoomType, updateRoomTypeDetails } from '../../../../../utils/ServicesAPIUtils';
import {
  allCategoriesSelector,
  allHotelsSelector,
  fetchAllAccommodations,
  selectedHotelCurrencySelector,
} from '../../../../property/propertySlice';
import './RoomType-Create.scss';
import CustomCheckbox from '../../../../../shared/form-controls/custom-checkbox/Custom-Checkbox';
import { decryptLocalStorage } from '../../../../../utils/authUtils';
import { stepDownLoaderCount, stepUpLoaderCount } from '../../../../../utils/loaderSlice';

import {
  decodeMediaKeyValue,
  renderVideos,
  renderGifs,
  toMediaContent,
  processGifsForUpload,
} from '../../../../../utils/mediaUtils';

const RoomTypeCreate = (props) => {
  const dispatch = useDispatch();
  const originalHotels = useSelector(allHotelsSelector);
  const currency = useSelector(selectedHotelCurrencySelector);
  const { toggleDrawer, roomType, hotelId, showLoader = () => {} } = props;
  const [isTabInValid, setIsTabInValid] = useState(true);
  const [rawImages, setRawImages] = useState([]);
  const [rawVideos, setRawVideos] = useState([]);
  const [rawGifs, setRawGifs] = useState([]);
  const [videoImageUrl, setVideoImageUrl] = useState('');
  const [gifImageUrl, setGifImageUrl] = useState('');
  const [hasVideoError, setHasVideoError] = useState(false);
  const [isThumbnailUploading, setIsThumbnailUploading] = useState(false);
  const [isVideoLoading, setIsVideoLoading] = useState(false);
  const [isGifLoading, setIsGifLoading] = useState(false);

  const groupId = originalHotels?.find((h) => h?.id === hotelId)?.groupId;

  const [formData, setFormData] = useReducer((state, newState) => ({ ...state, ...newState }), {
    categoryId: {
      value: '',
      fieldName: 'Select Category',
      errors: {},
      validations: ['required'],
      tab: 0,
    },
    code: {
      value: '',
      fieldName: 'Room Type Code',
      errors: {},
      validations: ['required', 'validAlphaNumeric'],
      tab: 0,
    },
    name: {
      value: '',
      fieldName: 'Room Type Name',
      errors: {},
      validations: ['required'],
      tab: 0,
    },
    ratePerNight: {
      value: '',
      fieldName: 'Rates per Night',
      errors: {},
      validations: ['positiveOnlyWithZero'],
      tab: 0,
    },
    displayName: {
      value: '',
      fieldName: 'Display Name',
      errors: {},
      validations: ['required'],
      tab: 0,
    },
    displayDescription: {
      value: '',
      fieldName: 'Display Description',
      errors: {},
      validations: ['required'],
      tab: 0,
    },
    maxOccupants: {
      value: '',
      fieldName: 'Maximum Occupants',
      errors: {},
      validations: ['positiveOnly'],
      tab: 0,
    },
    maxBeddingPerRoomType: {
      value: '',
      fieldName: 'Maximum Bedding per Room Type',
      errors: {},
      validations: ['positiveOnly'],
      tab: 0,
    },
    maxAdults: {
      value: '',
      fieldName: 'Maximum Adults',
      errors: {},
      validations: ['positiveOnly', 'maxOccupancy'],
      tab: 0,
    },
    maxChildren: {
      value: '',
      fieldName: 'Maximum Children',
      errors: {},
      validations: ['maxOccupancy'],
      tab: 0,
    },
    maxInfants: {
      value: '',
      fieldName: 'Maximum Infants',
      errors: {},
      validations: [],
      tab: 0,
    },
    isActive: {
      value: true,
      selected: true,
      fieldName: 'Active',
      errors: {},
      validations: [],
      tab: 0,
    },
    features: {
      value: [],
      fieldName: 'Highlight features',
      errors: {},
      validations: ['maxLimit'],
      maxLimit: 5,
      ignoreValidationOnSubmit: true,
      tab: 1,
    },
    description: {
      value: '',
      fieldName: 'Description',
      errors: {},
      validations: [],
      tab: 1,
    },
    images: {
      value: [],
      fieldName: 'Images',
      errors: {},
      validations: [],
      tab: 2,
    },
  });
  const categories = useSelector(allCategoriesSelector);
  const [tabValue, setTabValue] = useState(0);
  const [loading, setLoading] = useState(false);
  const emptyAllowedFields = [
    'ratePerNight',
    'maxAdults',
    'maxBeddingPerRoomType',
    'maxChildren',
    'maxInfants',
    'maxOccupants',
  ];

  useEffect(() => {
    if (roomType) {
      const currFields = { ...formData };
      for (let field in currFields) {
        if (emptyAllowedFields.includes(field) && roomType[field] === 0) {
          currFields[field].value = '';
        } else {
          if (field === 'maxInfants' || field === 'maxChildren') {
            currFields[field].value = roomType[field]?.toString?.() ?? '';
          } else {
            currFields[field].value = roomType[field];
          }
        }
      }
      currFields.isActive.selected = roomType.isActive || false;
      currFields.images.value = roomType.images || [];
      setFormData(currFields);

      const { Video: videoMediaContent, GIF: gifMediaContent } = decodeMediaKeyValue(
        roomType.mediaContent,
      );
      const videoData = videoMediaContent || roomType.videos || {};
      const gifData = gifMediaContent || roomType.gifs || {};
      setVideoImageUrl(videoData?.imageUrl || '');
      setGifImageUrl(gifData?.imageUrl || '');
      setRawVideos(renderVideos(videoData));
      setRawGifs(renderGifs(gifData));
    }
  }, [roomType]);

  const validateMaxOccupancies = () => {
    let isValidAllocation =
      Number(formData.maxOccupants.value) >=
      Number(formData.maxAdults.value) + Number(formData.maxChildren.value);
    const errMsg = 'Max adults and children values exceed total occupancy';
    const updatedFormFields = {
      maxAdults: formData.maxAdults,
      maxChildren: formData.maxChildren,
    };

    updatedFormFields.maxAdults.errors['maxOccupancy'] = isValidAllocation ? null : errMsg;
    updatedFormFields.maxChildren.errors['maxOccupancy'] = isValidAllocation ? null : errMsg;

    setFormData(updatedFormFields);
    return isValidAllocation;
  };

  const validate = (tabValue) => {
    const updatedFields = {};
    const currTabFromData = Object.fromEntries(
      Object.entries(formData).filter(([key, field]) => field.tab === tabValue),
    );

    const isValid = formDataValidate(currTabFromData, updatedFields);
    let isValidOccupancies = true;
    if (tabValue === 0) {
      isValidOccupancies = validateMaxOccupancies();
    }
    setFormData(updatedFields);
    return isValid && isValidOccupancies;
  };

  const onImageListUpdated = (imgObjArr) => {
    setRawImages(imgObjArr);
  };

  const onUploadedImageRemoval = (index) => {
    const images = [...formData.images.value];
    images.splice(index, 1);
    setFormData({ images });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (validate(0)) {
      dispatch(stepUpLoaderCount());
      const selectedLanguage = decryptLocalStorage('lang');
      const language = selectedLanguage !== 'en' ? selectedLanguage : '';
      setLoading(true);
      toggleDrawer('', false, '');
      const payload = {};
      // Populate payload

      for (let field in formData) {
        if (emptyAllowedFields.includes(field) && formData[field].value === '') {
          payload[field] = 0;
        } else {
          payload[field] = formData[field].value;
        }
      }

      try {
        // Process the image upload first and set the response to main payload
        payload.images = await getProcessedImages(
          rawImages,
          originalHotels.find((hotel) => hotel.id === hotelId).groupId,
          ASSET_ROOM_TYPES,
          hotelId,
        );
        const gifDataArr = await processGifsForUpload({
          rawGifs,
          groupId,
          propertyType: ASSET_ROOM_TYPES,
          hotelId,
        });

        const mediaContent = toMediaContent({
          videoList: rawVideos,
          videoImageUrl,
          gifList: gifDataArr,
          gifImageUrl,
        });

        payload.mediaContent = mediaContent;
        payload.isActive = formData.isActive.value;

        if (roomType) {
          payload.id = roomType.id;
          await updateRoomTypeDetails(payload, hotelId, language);
          notificationManager('success', 'Room Type updated successfully');
        } else {
          await creatNewRoomType(payload, hotelId, language);
          notificationManager('success', 'Room Type created successfully');
        }
        dispatch(fetchAllAccommodations(hotelId));
        setLoading(false);
      } catch (error) {
        setLoading(false);
        if (error?.graphQLErrors) {
          notificationManager('danger', error?.graphQLErrors?.[0]?.message);
        } else {
          roomType
            ? notificationManager('danger', 'RoomType updation failed')
            : notificationManager('danger', 'RoomType creation failed');
        }
      } finally {
        dispatch(stepDownLoaderCount());
      }
    } else {
      notificationManager('danger', 'Enter all required fields');
      setTabValue(0);
    }
  };

  const onCancel = (e) => {
    toggleDrawer('', false, '');
  };

  const handleTabChange = (event, newValue) => {
    if (newValue < tabValue) {
      setTabValue(newValue);
    } else if (validate(tabValue)) {
      setTabValue(newValue);
    }
  };

  const onNextClick = () => {
    if (validate(tabValue)) {
      setTabValue(tabValue + 1);
    }
  };

  const handleAddChip = (value) => {
    const currField = { ...formData.features };
    const currFeatures = currField.value ? [...currField.value] : [];

    if (currFeatures.findIndex((c) => value === c) === -1) {
      handleValidation(currField);
      if (!handleValidation(currField)) {
        currFeatures.push(value);
      }
      currField.value = currFeatures;
      setFormData({ features: currField });
    }
  };

  const handleDeleteChip = (index) => {
    const currField = { ...formData.features };
    const tempFeature = [...currField.value];
    tempFeature.splice(index, 1);
    currField.errors = {};
    currField.value = tempFeature;
    setFormData({ features: currField });
  };

  useEffect(() => {
    validateMaxOccupancies();
  }, [formData.maxOccupants, formData.maxAdults, formData.maxChildren]);

  useEffect(() => {
    const currTabFromData = Object.fromEntries(
      Object.entries(formData).filter(([key, field]) => field.tab === tabValue),
    );
    const isValid = formDataValidate(currTabFromData, false);
    setIsTabInValid(!isValid);
  }, [formData, tabValue]);

  return (
    <form className='roomtype-create' noValidate>
      <div className='container pt-4 d-flex align-items-end flex-column '>
        <div className='row px-3 w-100 mt-4'>
          <div className='col-md-3'>
            <span className='page-title'>{roomType ? 'Edit Room Type' : 'Add Room Type'}</span>
          </div>
          <div className='col-md-8'>
            <Tabs
              value={tabValue}
              variant='fullWidth'
              indicatorColor='primary'
              onChange={handleTabChange}
              aria-label='roomTypes-add-tabs'
              textColor='primary'
              className='property-tabs'
            >
              <Tab label='Details' />
              <Tab label='Features' />
              <Tab label='Media' />
            </Tabs>
          </div>
          <div className='col-md-1 d-flex justify-content-end'>
            <IconButton aria-label='delete' onClick={(e) => onCancel(e)}>
              <CancelIcon />
            </IconButton>
          </div>
        </div>

        <div className='row px-3 w-100 d-flex mt-4 form-scroll'>
          {tabValue === 0 && (
            <div className='row px-3 w-100 d-flex mt-4'>
              <h4 className='tab-title'>Details</h4>
              <div className='row'>
                <div className='col-md-6 mb-3'>
                  <CustomSelect
                    item={formData.categoryId}
                    handleInputChange={(e) => {
                      setFormData({ categoryId: e });
                    }}
                    options={categories}
                    hideNullOption={true}
                  />
                </div>
              </div>
              <div className='row'>
                <div className='col-md-6 mb-3'>
                  <CustomTextField
                    item={formData.name}
                    handleInputChange={(e) => {
                      setFormData({ name: e });
                    }}
                    maxLength={100}
                    endAdornment={true}
                    characterCount={true}
                    multiline={true}
                  />
                </div>
                <div className='col-md-6 mb-3'>
                  <CustomTextField
                    item={formData.code}
                    handleInputChange={(e) => {
                      setFormData({ code: e });
                    }}
                    maxLength={20}
                    endAdornment={true}
                    characterCount={true}
                    multiline={true}
                  />
                </div>
              </div>
              <div className='row'>
                <div className='col-md-6 mb-3'>
                  <CustomTextField
                    item={formData.displayName}
                    handleInputChange={(e) => {
                      setFormData({ displayName: e });
                    }}
                    maxLength={100}
                    endAdornment={true}
                    characterCount={true}
                    multiline={true}
                  />
                </div>
              </div>
              <div className='row'>
                <div className='col-md-12 mb-3'>
                  <CustomTextField
                    item={formData.displayDescription}
                    handleInputChange={(e) => {
                      setFormData({ displayDescription: e });
                    }}
                    multiline={true}
                  />
                </div>
              </div>
              <div className='row'>
                <div className='col-md-6 mb-3'>
                  <CustomTextField
                    min={0}
                    max={10000000}
                    type='number'
                    item={formData.ratePerNight}
                    handleInputChange={(e) => {
                      setFormData({ ratePerNight: e });
                    }}
                    startAdroment={true}
                    adromentValue={currency}
                    hideAdornmentByDefault={true}
                  />
                </div>
              </div>
              <div className='row px-3 w-100 d-flex mt-2'>
                <div className='col-md-6 mb-3'>
                  <CustomCheckbox
                    item={formData.isActive}
                    handleInputChange={(e) => {
                      setFormData({ isActive: e });
                    }}
                    color='primary'
                  />
                </div>
              </div>
              <h4 className='tab-title mt-4'>Occupancy</h4>
              <div className='row'>
                <div className='col-md-6 mb-3'>
                  <CustomTextField
                    type='number'
                    item={formData.maxOccupants}
                    min={0}
                    handleInputChange={(e) => {
                      setFormData({ maxOccupants: e });
                    }}
                    max={99}
                  />
                </div>
                <div className='col-md-6 mb-3'>
                  <CustomTextField
                    type='number'
                    item={formData.maxBeddingPerRoomType}
                    handleInputChange={(e) => {
                      setFormData({ maxBeddingPerRoomType: e });
                    }}
                    min={0}
                    max={99}
                  />
                </div>
                <div className='col-md-6 mb-3'>
                  <CustomTextField
                    type='number'
                    item={formData.maxAdults}
                    handleInputChange={(e) => {
                      setFormData({ maxAdults: e });
                    }}
                    disabled={
                      !formData.maxOccupants.value || Number(formData.maxOccupants.value) < 1
                    }
                    min={0}
                    max={99}
                  />
                </div>
                <div className='col-md-6 mb-3'>
                  <CustomTextField
                    type='number'
                    item={formData.maxChildren}
                    handleInputChange={(e) => {
                      setFormData({ maxChildren: e });
                    }}
                    disabled={
                      !formData.maxOccupants.value || Number(formData.maxOccupants.value) < 1
                    }
                    min={0}
                    max={99}
                  />
                </div>
              </div>
              <div className='row'>
                <div className='col-md-6 mb-3'>
                  <CustomTextField
                    type='number'
                    item={formData.maxInfants}
                    handleInputChange={(e) => {
                      setFormData({ maxInfants: e });
                    }}
                    min={0}
                    max={99}
                  />
                </div>
                <div className='col-md-6 mb-3 gray-text info-text'>
                  (Number of Infants do not count towards the Maximum number of occupants)
                </div>
              </div>
            </div>
          )}
          {tabValue === 1 && (
            <div className='row px-3 w-100 d-flex mt-4'>
              <div className='col-md-12 mb-3'>
                <h4 className='tab-title '>Features</h4>
                <div className='row mt-4'>
                  <div className='col-md-12 mb-3 d-flex align-items-center'>
                    <ChipInput
                      value={formData.features.value}
                      onAdd={(chip) => handleAddChip(chip)}
                      label={formData.features.fieldName}
                      fullWidth
                      readOnly={true}
                      error={formData.features.errors.maxLimit ? true : false}
                      helperText={formData.features.errors.maxLimit}
                      chipRenderer={(
                        { value, isFocused, isDisabled, handleClick, handleRequestDelete },
                        key,
                      ) => (
                        <Chip
                          key={key}
                          variant='outlined'
                          color='primary'
                          className='me-2 custom-primary-chip'
                          label={value}
                          deleteIcon={<Close />}
                          onDelete={() => handleDeleteChip(key)}
                        ></Chip>
                      )}
                    />
                    <div className='gray-text'>
                      {formData.features.value?.length}/{formData.features.maxLimit}
                    </div>
                  </div>
                  <div className='col-md-12 mt-3 d-flex align-items-center'>
                    <InputLabel id={'suggested_label'}>Suggested:</InputLabel>
                    <div className='ms-3'>
                      {SuggestedRoomTypeFeatures?.map((feature, i) => (
                        <Chip
                          key={i}
                          label={feature}
                          className='me-3 mb-2'
                          variant='outlined'
                          onClick={() => handleAddChip(feature)}
                        />
                      ))}
                    </div>
                  </div>
                  <div className='col-md-12 mt-5 mb-3'>
                    {RoomTypeFeatures?.map((feature, i) => (
                      <Chip
                        key={i}
                        label={feature}
                        className='me-3 mb-2'
                        variant='outlined'
                        onClick={() => handleAddChip(feature)}
                      />
                    ))}
                  </div>
                </div>
                <div className='row'>
                  <div className='col-md-12 mb-3'>
                    <CustomTextField
                      item={formData.description}
                      handleInputChange={(e) => {
                        setFormData({ description: e });
                      }}
                      multiline={true}
                    />
                  </div>
                </div>
              </div>
            </div>
          )}
          {tabValue === 2 && (
            <div className='row px-3 w-100 d-flex mt-4'>
              <div className='col-md-12 mb-3'>
                <ImageUpload
                  uploadedImages={formData.images.value}
                  imgList={rawImages}
                  onImageListUpdated={onImageListUpdated}
                  onUploadedImageRemoval={onUploadedImageRemoval}
                  onImagesLoading={(status) => {
                    setLoading(status);
                  }}
                  videoImageUrl={videoImageUrl}
                  onVideoImageUrlChange={setVideoImageUrl}
                  gifImageUrl={gifImageUrl}
                  onGifImageUrlChange={setGifImageUrl}
                  videoList={rawVideos}
                  gifList={rawGifs}
                  onVideoListUpdated={setRawVideos}
                  onGifListUpdated={setRawGifs}
                  hotelId={hotelId}
                  groupId={groupId}
                  propertyType={ASSET_ROOM_TYPES}
                  onVideoError={setHasVideoError}
                  onThumbnailUploading={setIsThumbnailUploading}
                  onVideoLoading={setIsVideoLoading}
                  onGifLoading={setIsGifLoading}
                />
              </div>
            </div>
          )}
        </div>
        <div className='row mx-2 mt-auto px-4 w-100 pb-5'>
          <div className='col-md-12 d-flex justify-content-start'>
            {tabValue < 2 ? (
              <Button
                variant='contained'
                color='primary'
                onClick={onNextClick}
                size='large'
                className='me-3'
                disabled={isTabInValid || hasVideoError || isThumbnailUploading || isVideoLoading || isGifLoading}
              >
                Next
              </Button>
            ) : (
              <Button
                disabled={loading || hasVideoError || isThumbnailUploading || isVideoLoading || isGifLoading}
                onClick={handleSubmit}
                variant='contained'
                color='primary'
                className='me-3'
                size='large'
              >
                {roomType ? 'Update' : 'Add'}
              </Button>
            )}
            <Button
              disabled={loading}
              variant='outlined'
              type='button'
              color='secondary'
              size='large'
              onClick={(e) => onCancel(e)}
            >
              Cancel
            </Button>
          </div>
          {loading && <div className='pt-4 col-md-12'>{<LinearProgressBar />}</div>}
        </div>
      </div>
    </form>
  );
};

export default RoomTypeCreate;
